import React, { useEffect, useState } from 'react';

export type CccWorkspaceUserOption = {
  id: number;
  name: string;
  username?: string;
  email?: string;
};

type Props = {
  open: boolean;
  users: CccWorkspaceUserOption[];
  submitting?: boolean;
  title?: string;
  transferHint?: string;
  confirmLabel?: string;
  onClose: () => void;
  onConfirm: (userId: number) => void;
};

const CccAlterarComercialModal: React.FC<Props> = ({
  open,
  users,
  submitting = false,
  title = 'Alterar Comercial',
  transferHint = 'Será transferido para:',
  confirmLabel = 'Confirmar',
  onClose,
  onConfirm,
}) => {
  const [userId, setUserId] = useState<string>('');

  useEffect(() => {
    if (open) setUserId('');
  }, [open]);

  if (!open) return null;

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const parsed = Number(userId);
    if (!Number.isFinite(parsed)) return;
    onConfirm(parsed);
  };

  return (
    <div
      className="rec-modal-backdrop"
      onClick={() => !submitting && onClose()}
      role="presentation"
    >
      <div
        className="rec-modal rec-modal--alterar-comercial"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-labelledby="ccc-alterar-comercial-title"
      >
        <div className="rec-modal-head">
          <h2 id="ccc-alterar-comercial-title" className="rec-modal-title">
            {title}
          </h2>
        </div>
        <form className="rec-modal-body" onSubmit={handleSubmit}>
          <p className="rec-modal-text rec-modal-text--transfer">{transferHint}</p>
          <label className="rec-lead-field rec-lead-field--no-label">
            <select
              className="rec-select"
              value={userId}
              onChange={(e) => setUserId(e.target.value)}
              required
              disabled={submitting}
              aria-label="Comercial de destino"
            >
              <option value="">Selecionar utilizador…</option>
              {users.map((u) => (
                <option key={u.id} value={String(u.id)}>
                  {u.name}
                  {u.username ? ` (${u.username})` : ''}
                </option>
              ))}
            </select>
          </label>
          <div className="rec-modal-actions">
            <button
              type="button"
              className="rec-btn rec-btn-ghost"
              disabled={submitting}
              onClick={onClose}
            >
              Cancelar
            </button>
            <button type="submit" className="rec-btn rec-btn-primary" disabled={submitting}>
              {submitting ? 'A guardar…' : confirmLabel}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CccAlterarComercialModal;
